import { render, staticRenderFns } from "./form-docs.vue?vue&type=template&id=c45b2f70&lang=pug&"
import script from "./form-docs.vue?vue&type=script&lang=js&"
export * from "./form-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports